var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "block-header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.nama))])]), _vm._v(" "), _c('div', {
    staticClass: "row clearfix"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("\n                            List " + _vm._s(_vm.nama) + "\n                        ")]), _vm._v(" "), _c('ul', {
    staticClass: "header-dropdown m-r--5 m-t--10"
  }, [_c('router-link', {
    directives: [{
      name: "waves",
      rawName: "v-waves.button",
      modifiers: {
        "button": true
      }
    }],
    staticClass: "btn btn-primary waves-effect waves-button",
    attrs: {
      "to": '/main/informasi/' + _vm.link + '/tambah',
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "material-icons",
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("add_box")]), _vm._v(" "), _c('span', [_vm._v("Tambah")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "DataTables_Table_0_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "DataTables_Table_0_length"
    }
  }, [_c('label', [_vm._v("Show "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.perPage),
      expression: "perPage"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "name": "DataTables_Table_0_length",
      "aria-controls": "DataTables_Table_0"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.perPage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _c('option', {
    attrs: {
      "value": "25"
    }
  }, [_vm._v("25")]), _c('option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("50")]), _c('option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v("100")])]), _vm._v(" entries")])])]), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_filter",
    attrs: {
      "id": "DataTables_Table_0_filter"
    }
  }, [_c('label', [_vm._v("Search:"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "search",
      "placeholder": "",
      "aria-controls": "DataTables_Table_0"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped table-hover js-basic-example dataTable"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(_vm.isLoading) ? _c('tr', [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.list == '') ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("Data tidak ditemukan")])]) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _vm._l((_vm.list), function(item, index) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(++index + ((_vm.currentPage - 1) * _vm.perPage)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nip))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nomorHp))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.jenisPengajuan))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.stripTags(item.pesan)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.createdAt ? _vm.$moment(item.createdAt, 'YYYY-MM-DD').format("Do MMMM YYYY") : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.jawaban))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn bg-green waves-effect",
      staticStyle: {
        "padding": "4px 8px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.$router.push('/main/layanan/' + _vm.link + '/' + item.id)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("create")])]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger waves-effect",
      staticStyle: {
        "padding": "4px 8px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.confirmDelete(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("delete")])])])])
  }) : _vm._e()], 2)])]), _vm._v(" "), _c('pagination', {
    attrs: {
      "total-rows": _vm.result.totalElements,
      "per-page": _vm.result.size
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("No.")]), _vm._v(" "), _c('th', [_vm._v("Nip")]), _vm._v(" "), _c('th', [_vm._v("No Hp")]), _vm._v(" "), _c('th', [_vm._v("Jenis Pengajuan")]), _vm._v(" "), _c('th', [_vm._v("Pertanyaan")]), _vm._v(" "), _c('th', [_vm._v("Tanggal")]), _vm._v(" "), _c('th', [_vm._v("Jawaban")]), _vm._v(" "), _c('th', [_vm._v("Aksi")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "5"
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Loading data...")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6dce6bac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/KritikdanSaran/KritikDanSaranList.vue
// module id = MSf0
// module chunks = 1